import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
} from '@chakra-ui/react';
import { animated as a, useSpring } from 'react-spring';
import { useWindowSize } from 'react-use';

import { Link } from 'gatsby';
import React, { useEffect } from 'react';
import { generate } from 'shortid';

const MobileROUTES = [
  {
    name: 'About us',
    to: '/about',
    id: generate(),
  },
  {
    name: 'Blog',
    to: '/blog',
    id: generate(),
  },
  {
    name: 'FAQ',
    to: '/faq',
    id: generate(),
  },
  {
    name: 'Contact Us',
    to: '/contact',
    id: generate(),
  },
];

const MobileNav = ({
  styles, show, setShow, ROUTES,
}) => {
  const { width } = useWindowSize();
  useEffect(() => {
    console.log('mobile', window.scrollY);
    if (width > 975 && window.scrollY === 0) {
      setShow(false);
    }
  }, [width]);

  return (
    <a.div
      style={{
        ...styles,
        position: 'fixed',
        top: '0px',
        zIndex: '50',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: 'white',
      }}
    >
      <Container maxW="container.md">
        <Flex
          minheight="100vh"
          flexDirection="column"
          alignItems="flex-end"
          overflow="hidden"
          backgroundColor="white"
          pt={40}
        >
          {ROUTES.map((r) => (
            <Box
              pr={4}
              key={`route${r.id}`}
            >
              <Heading
                as="h4"
                mb={6}
                size="xl"
                onClick={() => setShow(!show)}
              >
                <Link to={`${r.to}`}>{r.name}</Link>
              </Heading>
            </Box>
          ))}
          {MobileROUTES.map((r) => (
            <Box
              pr={4}
              key={`route${r.id}`}
            >
              <Heading
                as="h4"
                mb={6}
                size="xl"
                onClick={() => setShow(!show)}
              >
                <Link to={`${r.to}`}>{r.name}</Link>
              </Heading>
            </Box>
          ))}
          <Link to="/get-offer/#get-offer-form">
            <Button
              variant="btnCTA"
              onClick={() => setShow(!show)}
            >
              Get your offer
            </Button>
          </Link>
        </Flex>
      </Container>
    </a.div>
  );
};

export default MobileNav;
